
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import BackToTop from "@/components/ui/BackToTop";
import { HeartHandshake, AlertTriangle, ThumbsUp } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const CodeOfConduct = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        <div className="container mx-auto px-4 py-12 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-nation-blue mb-4">Code of Conduct</h1>
            <p className="text-gray-600">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
          
          <div className="grid gap-8">
            <Card className="border-l-4 border-l-nation-teal shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <HeartHandshake className="w-6 h-6 text-nation-teal flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">1. Purpose</h2>
                    <p className="text-gray-700 leading-relaxed">
                      Our Code of Conduct outlines our expectations for all participants within the NationCard™
                      community, whether contributing data, participating in discussions, or using our services.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-l-4 border-l-nation-teal shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <ThumbsUp className="w-6 h-6 text-nation-teal flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">2. Expected Behavior</h2>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700">
                      <li>Be respectful and inclusive</li>
                      <li>Exercise consideration and empathy</li>
                      <li>Refrain from discriminatory behavior</li>
                      <li>Be mindful of your language and approach</li>
                      <li>Listen actively and accept constructive feedback</li>
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-l-4 border-l-nation-teal shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <AlertTriangle className="w-6 h-6 text-nation-teal flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">3. Unacceptable Behavior</h2>
                    <p className="text-gray-700 mb-4 leading-relaxed">
                      The following behaviors are considered unacceptable within our community:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700">
                      <li>Harassment or discrimination</li>
                      <li>Hate speech or personal attacks</li>
                      <li>Trolling or derogatory comments</li>
                      <li>Spamming or disruptive behavior</li>
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default CodeOfConduct;
